import { render, staticRenderFns } from "./NewPublish.vue?vue&type=template&id=fc1d5e84&scoped=true"
import script from "./NewPublish.vue?vue&type=script&lang=js"
export * from "./NewPublish.vue?vue&type=script&lang=js"
import style0 from "./NewPublish.vue?vue&type=style&index=0&id=fc1d5e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1d5e84",
  null
  
)

export default component.exports